<template>
  <div class="left-view">
    <div class="box-overlay"></div>
    <div class="logo-container">
      <img src="../../assets/images/talent-logo-default-monochrome.svg" alt="Talent Logo" />
    </div>

    <div class="left-container">
      <img class="left-view-img" v-bind:src="coverImage" alt="background image" />
    </div>

  </div>
</template>
<script>
export default {
  name: 'LeftView',
  props:['coverImage'],
  components: {  },
  data() {
    return {

    };
  },
};
</script>
<style>
  .left-view {
    height:100%;
    width:50%;
    position: relative;
  }

  .logo-container {
    position:absolute;
    left:44px;
    top:44px;
    z-index:3
  }

  .logo-container img {
    width:150px;
  }

  .left-view-img {
    width:100%;
    height:100vh;
    object-fit: cover;
  }


  .box-overlay {
    background: linear-gradient(133.07deg, rgba(43, 61, 110, 0.82) 14.27%, rgba(2, 95, 160, 0.5576) 155%);
    opacity: .8;
    position: absolute;
    z-index: 2;
    width: 100%;
    height: 100%;
}

  @media only screen and (max-width:990px) {
    .left-view{
      width:100%;
      margin-bottom:80px;
    }

    .box-overlay{
      width:100%;
    }
  }
</style>
